import { jsx as _jsx } from "react/jsx-runtime";
import NavLink from '../NavLink/NavLink';
const MobileBackToMenu = ({ changeMenu }) => {
    return (_jsx("ul", { children: _jsx(NavLink, { label: "Back to menu", goBackward: true, onClick: () => changeMenu('back'), isFromMegaNavMobile: true }) }));
};
export default MobileBackToMenu;
